<template>
  <div v-if="variant.key === 'smartbox'">
    <div class="col-12 col-sm-10 offset-sm-1">
      <div class="logo-container">
        <div class="partner-logo">
          <router-link class="avp-logo" to="/">
            <SmartboxLogo alt="Logo der Smartbox GmbH" class="icon logo"/>
          </router-link>
        </div>
        <div class="coop-block">
          <span>In Kooperation mit</span>
          <AnimodLogo alt="Logo der Animod GmbH" class="icon logo"/>
        </div>
      </div>
      <div class="col-12">
        <i18n path="header.title.text" tag="h1">
          <span slot="brand">{{ variant.brand || 'Animod' }}</span>
        </i18n>
      </div>
    </div>
  </div>
  <div v-else-if="variant.key === 'kurzinurlaub'">
      <div class="col-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
          <router-link class="avp-logo" to="/">
              <KurzInUrlaubLogo alt="Logo der Kurz in Urlaub / Animod GmbH" class="icon logo"/>
          </router-link>
      </div>
      <div class="col-12">
          <i18n path="header.title.text" tag="h1">
              <span slot="brand">{{ variant.brand || 'Kurz in Urlaub' }}</span>
          </i18n>
      </div>
  </div>
  <div v-else>
    <div class="col-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
      <router-link class="avp-logo" to="/">
        <AnimodLogo alt="Logo der Animod GmbH" class="icon logo"/>
      </router-link>
    </div>
    <div class="col-12">
      <i18n path="header.title.text" tag="h1">
        <span slot="brand">{{ variant.brand || 'Animod' }}</span>
      </i18n>
    </div>
  </div>
</template>

<script>
import AnimodLogo from '@/assets/animod_logo_variations.svg';
import SmartboxLogo from '@/assets/smartbox_logo.svg';
import KurzInUrlaubLogo from '@/assets/kurzinurlaub_logo.svg';

export default {
  name: 'CardHeader',
  components: {
    AnimodLogo,
    SmartboxLogo,
    KurzInUrlaubLogo
  },
  props: {
    variant: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "@/styles/_variables";
@use "sass:map";

$header-color: map.get(variables.$colors, 'header');

h1 {
  color: $header-color;
  display: block;
  font-size: 1.5rem;
  margin: 0.625rem auto;
  text-align: center;
}

.avp-card-header {
  .logo-container {
    display:flex;

    .partner-logo, .coop-block {
      flex: 50%;
    }

    .coop-block {
      border-left: 1px dotted #ccc;
      margin-left: 10px;
      padding-left: 10px;
      padding-top: 10px;
      span {
        color: #666;
        font-size: 12px;
        text-align: justify-all;
      }
      svg {
        max-width: 120px;
        max-height: 35px;
        filter: grayscale(100%) brightness(1.2) opacity(.8);
        //opacity: .9;
      }
    }
  }

  .avp-logo {
    .logo {
      display: block;
      height: 3.75rem;
      margin: 0 auto;
      max-width: 100%;
      color: $header-color;

      @media (min-width: 576px) {
        height: 3.75rem;
      }
      @media (min-width: 768px) {
        height: 2.5rem;
      }
      @media (min-width: 992px) {
        height: 5rem;
      }
      @media (min-width: 1200px) {
        height: 6.25rem;
      }
    }
  }

  h1 {
    color: $header-color;
    display: block;
    font-size: 1.5rem;
    margin: 0.625rem auto;
    text-align: center;
  }
}
</style>
